// unluckily, there is no ts package
// docs - https://tapfiliate.com/docs/integrations/npm-module/
// @ts-ignore
import Tap from '@tapfiliate/tapfiliate-js';
import { formatAmount } from './price/price.utils';

let isInitialized = false;

export const initTapfiliate = () => {
  if (process.env.REACT_APP_TAPFILIATE_ACCOUNT_ID && !isInitialized) {
    Tap.init(process.env.REACT_APP_TAPFILIATE_ACCOUNT_ID);
    isInitialized = true;
  }
};

export const markConversion = (
  accountId: string,
  params: {
    amountInCents: number;
    currencyIsoCode: string;
  }
) => {
  if (isInitialized) {
    Tap.conversion(accountId, formatAmount(params.amountInCents), {
      customer_id: accountId,
      currency: params.currencyIsoCode,
    });
  } else {
    console.log('[Tapfiliate Mock] conversion', accountId, formatAmount(params.amountInCents), {
      customer_id: accountId,
      currency: params.currencyIsoCode,
    });
  }
};
